import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreditCard } from 'src/app/shared-core/models/payer-auth.model';
import { hasError, VistekValidation } from 'src/app/shared-core/services/validation.service';
var valid = require("card-validator");

const creditCardValidator = VistekValidation.creditCardValidator;
const required = Validators.required;
const minLength = Validators.minLength;
const maxLength = Validators.maxLength;

@Component({
    selector: 'app-credit-card-form',
    templateUrl: './credit-card-form.component.html',
    styleUrls: ['./credit-card-form.component.scss']
})
export class CreditCardFormComponent implements OnInit {
    @Output() validCardDetected = new EventEmitter<{ cardType: string}>();
    @Input() public hideNameField = false;
    public paymentForm: FormGroup = null;
    public isAmericanExpress = false;

    get codeLabel(): string {
        return this.isAmericanExpress ? 'CID' : 'CVV';
    }

    constructor(private _fb: FormBuilder) {}

    public ngOnInit(): void {
        this.initCreditCardForm();
    }

    public hasError = (formControlName: string): boolean => {
        return hasError(this.paymentForm, formControlName, null);
    };

    public isValid(): boolean {
        this.paymentForm.updateValueAndValidity();
        this.paymentForm.markAllAsTouched();   

        return this.paymentForm.valid;
    }

    public getCreditCard(): CreditCard {
        return this.paymentForm.value;
    }

    private initCreditCardForm(): void {
        const form = this.paymentForm;

        let formFields = {
            accountNumber: [form?.get('accountNumber').value, [required, creditCardValidator('number')]],
            cardCode: [form?.get('cardCode').value, [required, creditCardValidator('cvv')]],
            expirationMonth: [form?.get('expirationMonth').value, [required, creditCardValidator('month'), minLength(2), maxLength(2)]],
            expirationYear: [form?.get('expirationYear').value, [required, creditCardValidator('year'), minLength(4), maxLength(4)]]
        } as any;

        if (!this.hideNameField) {
            formFields.nameOnAccount = [form?.get('nameOnAccount').value, [required, creditCardValidator('name')]];
        }

        this.paymentForm = this._fb.group(formFields);

        this.paymentForm.get('accountNumber').valueChanges.subscribe(number => {
            const validationResult = valid.number(number);

            if (validationResult.card) {
                const isAmex = validationResult.card.type === 'american-express';

                if (this.isAmericanExpress !== isAmex) {
                    const validatorFn = isAmex ? creditCardValidator('cid') : creditCardValidator('cvv');
                    this.isAmericanExpress = isAmex;

                    this.paymentForm.get('cardCode').setValidators([validatorFn]);
                    this.paymentForm.get('cardCode').updateValueAndValidity();
                }

                // Emit event when a valid card is detected
                this.validCardDetected.emit({
                    cardType: validationResult.card.type
                });
            }
        });
    }
}
